import React from 'react';
import { IconProps } from '.';

const SvgColoredCheck = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill='#23AE50'
        d='M9.727 19.141a1.5 1.5 0 0 1-2.153 0l-4.31-4.44a1.5 1.5 0 0 1 0-2.09l.825-.85a1.5 1.5 0 0 1 2.154.003L8.65 14.25l9.107-9.391a1.5 1.5 0 0 1 2.153 0l.826.85a1.5 1.5 0 0 1 0 2.09L9.726 19.14Z'
      />
    </svg>
  );
};

export default SvgColoredCheck;
